export default __webpack_public_path__ + "static/media/wheelchair.e993981e.svg";